import { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import SucessModal from "../successModal/SuccessModal.js";
import { toast } from "sonner";
import "../../.csscode/PopUpModal.css";
import {
  FaEye,
  FaEyeSlash,
  FaUser,
  FaMapMarkerAlt,
  FaLock,
  FaPhoneAlt,
  FaEnvelope,
  FaPen,
  FaTrashAlt,
  FaHome,
  FaBuilding,
  FaSave,
  FaPlus,
  FaTimes,
  FaSearch,
  FaBriefcase,
} from "react-icons/fa";
import { confirmDelete, showSuccessAlert } from "../../Swal.js";
import { getDropDownVal } from "../dropdownUtils.js";
import CustomLoader from "../static/CustomLoader.js";
import { profileCss, selectStyles } from "./Sampempprofilestyles.js";

const Field = ({ label, required, error, span = "ep-c6", children }) => (
  <div className={`ep-field ${span}`}>
    <label className="ep-label">
      {label}
      {required && <span className="ep-req">*</span>}
    </label>
    {children}
    {error && <span className="ep-error">{error}</span>}
  </div>
);

const SampEmpProfile = () => {
  const userdetails = JSON.parse(localStorage.getItem("user"));
  const usercd = userdetails ? userdetails.empcode : 0;
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [errors, setErrors] = useState({});
  const [pincodeError, setPincodeError] = useState("");
  const [supervisorOptions, setSupervisorOptions] = useState([{}]);
  const [divisionData, setDivisionData] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [ctypeOptions, setCtypeOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingc, setLoadingc] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [newItem, setNewItem] = useState({
    id: "",
    code: "",
    name: "",
    lastname: "",
    gender: "",
    empid: "",
    supervisor: "",
    department: "",
    designation: "",
  });
  //empcontact
  const [empcontact, setEmpcontact] = useState([]);
  const [newodtItem, setNewodtItem] = useState({
    id: "",
    addressline1: "",
    addressline2: "",
    pincode: "",
    city: "",
    dist: "",
    state: "",
    country: "",
    primaryphone: "",
    secondaryphone: "",
    emailid: "",
    empcode: "",
    ctype: "",
  });
  const [newUser, setNewUser] = useState({
    id: "",
    userid: "",
    password: "",
    empcode: "",
    active: "",
    type: "",
    versionapp: "",
    versionexp: "",
    apptoken: "",
  });
  //password visibility
  const [showPassword, setShowPassword] = useState(false);
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
  };

  const handleTabChange = (_, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    fetchDivisions();
  }, []);

  useEffect(() => {
    const fetchEmpDetailsByCode = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl}employee/byCode/${usercd}`, {
          headers,
        });
        if (response.data.cd === 1) {
          toast.error(response.data.description);
          setLoading(false);
        } else {
          const { empContacts, employee, user } = response.data;

          setEmpcontact(empContacts || []);
          setNewItem({
            id: employee.id || "",
            empid: employee.empid || "",
            code: employee.code || "",
            name: employee.name || "",
            lastname: employee.lastname || "",
            gender: employee.gender || "",
            supervisor: parseFloat(employee.supervisor),
            department: parseFloat(employee.department),
            designation: employee.designation || "",
          });
          setNewodtItem({
            id: empContacts.id || "",
            addressline1: empContacts.addressline1 || "",
            addressline2: empContacts.addressline1 || "",
            pincode: empContacts.pincode || "",
            city: empContacts.city || "",
            dist: empContacts.dist || "",
            state: empContacts.state || "",
            country: empContacts.country || "",
            primaryphone: empContacts.primaryphone || "",
            secondaryphone: empContacts.primaryphone || "",
            emailid: empContacts.emailid || "",
            empcode: empContacts.empcode || "",
            ctype: empContacts.ctype || "",
          });
          setNewUser({
            id: user.id || "",
            userid: user.userid || "",
            password: user.password || "",
            empcode: user.empcode || "",
            active: user.active || "",
            type: user.type || "",
            versionapp: user.versionapp || "",
            versionexp: user.versionexp || "",
            apptoken: user.apptoken || "",
          });
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching employee details:", error);
        toast.error("Failed to fetch employee details.");
      } finally {
        setLoading(false);
      }
    };

    if (usercd) {
      fetchEmpDetailsByCode();
    }
  }, [apiUrl, usercd]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}employee`, { headers });
        const employeeOptions = response.data.map((op) => ({
          value: op.code,
          label: op.name,
        }));

        setSupervisorOptions(employeeOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [apiUrl]);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  useEffect(() => {
    const fetchGenderOptions = () => {
      try {
        const response = getDropDownVal("GN");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setGenderOptions(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    fetchGenderOptions();
  }, []);

  useEffect(() => {
    const fetchCtypeOptions = () => {
      try {
        const response = getDropDownVal("ADD");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setCtypeOptions(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    fetchCtypeOptions();
  }, []);

  function clearFieldContact() {
    setNewodtItem({
      addressline1: "",
      addressline2: "",
      pincode: "",
      city: "",
      dist: "",
      state: "",
      country: "",
      primaryphone: "",
      secondaryphone: "",
      emailid: "",
      ctype: "",
    });
  }

  const validateUpdateFields = () => {
    let errors = {};
    if (!newItem.name.trim()) errors.name = "Name is required.";
    if (!newItem.gender) errors.gender = "Gender is required.";
    if (!newItem.empid) errors.empid = "Employee Id is required.";
    if (!newItem.department) errors.department = "Department is required.";
    return errors;
  };

  const handleUpdateEmployee = async () => {
    setLoading(true);

    const fieldErrors = validateUpdateFields();
    setErrors(fieldErrors);

    if (Object.keys(fieldErrors).length > 0) {
      toast.error("Please correct the errors in the form.");
      setLoading(false);
      return;
    }

    const emp = {
      id: newItem.id,
      code: newItem.code,
      name: newItem.name,
      lastname: newItem.lastname,
      gender: newItem.gender,
      empid: newItem.empid,
      supervisor: newItem.supervisor,
      department: newItem.department,
      designation: newItem.designation,
    };

    const empUser = newUser.password
      ? {
          id: newUser.id,
          userid: newItem.empid,
          password: newUser.password,
          empcode: newItem.code,
          active: newUser.active,
          type: 1,
          versionapp: newUser.versionapp,
          versionexp: newUser.versionexp,
          apptoken: newUser.apptoken,
        }
      : null;

    const empRegistrationData = {
      employee: emp,
      user: empUser,
      empContacts: empcontact,
    };

    try {
      const response = await axios.put(
        `${apiUrl}employee`,
        empRegistrationData,
        { headers },
      );
      if (response.data.cd === 1) {
        setSucessMessage(response.data.description);
        setTitle("⚠️ Failed");
        setShowSucessModal(true);
        setLoading(false);
      } else {
        setSucessMessage(response.data.description);
        setTitle("✔️Success");
        setShowSucessModal(true);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error updating employee:", error);
      setLoading(false);
      toast.error("An error occurred while updating the employee.");
    }
  };

  const handleUpdateContact = async () => {
    setLoading(true);
    if (empcontact.length == 0) {
      toast.error("Please add one Contact details.");
      setLoading(false);
      return;
    }
    try {
      await axios
        .put(apiUrl + "empcontact", empcontact, { headers })
        .then((response) => {
          if (response.data.cd === 1) {
            setSucessMessage(response.data.description);
            setTitle("⚠️ Failed");
            setShowSucessModal(true);
            setLoading(false);
          } else {
            setSucessMessage(response.data.description);
            setTitle("✔️Success");
            setShowSucessModal(true);
            setLoading(false);
            window.location.reload();
          }
        });
      setNewodtItem({
        id: "",
        addressline1: "",
        addressline2: "",
        pincode: "",
        city: "",
        dist: "",
        state: "",
        country: "",
        primaryphone: "",
        secondaryphone: "",
        emailid: "",
        empcode: newItem.code,
        ctype: "",
      });
    } catch (error) {
      console.error("Error saving item:", error);
    }
  };

  const validateContactFields = () => {
    let errors = {};
    const isNumeric = (value) => /^[0-9]{10}$/.test(value);
    const isSixDigitPincode = (value) => /^[0-9]{6}$/.test(value);
    const isValidEmail = (value) => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(value);
    };
    if (!isNumeric(newodtItem.primaryphone)) {
      errors.primaryphone = "Phone Number must be exactly 10 digits..!";
    }
    if (newodtItem.secondaryphone && !isNumeric(newodtItem.secondaryphone)) {
      errors.secondaryphone = "Phone Number must be exactly 10 digits..!";
    }
    if (!newodtItem.addressline1.trim())
      errors.addressline1 = "Address 1 is required.";
    if (!isSixDigitPincode(newodtItem.pincode)) {
      errors.pincode = "Pincode must be required  ";
    }
    if (!newodtItem.dist.trim()) errors.dist = "District is required.";
    if (!newodtItem.ctype) {
      errors.ctype = "Address Type is Required..!";
    }
    if (newodtItem.emailid && !isValidEmail(newodtItem.emailid)) {
      errors.emailid =
        "Invalid email format. Please enter a valid email address.";
    }
    return errors;
  };

  const fetchDivisions = async () => {
    setLoading(true);
    try {
      const response = await axios.get(apiUrl + "division", {
        headers,
      });
      const divOptions = response.data.map((op) => ({
        value: op.code,
        label: op.name,
      }));
      setDivisionData(divOptions);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddContact = () => {
    const fieldErrors = validateContactFields();
    setErrors(fieldErrors);
    if (Object.keys(fieldErrors).length > 0) {
      toast.error("Please correct the errors in the form.");
      return;
    }
    if (newodtItem.id) {
      const updatedContacts = empcontact.map((doc) =>
        doc.id === newodtItem.id ? newodtItem : doc,
      );
      setEmpcontact(updatedContacts);
    } else {
      setEmpcontact([...empcontact, { ...newodtItem, empcode: newItem.code }]);
    }
    setNewodtItem({
      id: "",
      addressline1: "",
      addressline2: "",
      pincode: "",
      city: "",
      dist: "",
      state: "",
      country: "",
      primaryphone: "",
      secondaryphone: "",
      emailid: "",
      empcode: newItem.code,
      ctype: "",
    });
  };

  const handleContactChange = async (field, value) => {
    setNewodtItem({ ...newodtItem, [field]: value });

    if (field === "pincode") {
      const enteredPincode = value.trim();
      setPincodeError("");

      if (enteredPincode.length !== 6 || isNaN(enteredPincode)) {
        setPincodeError("and Please enter a valid 6-digit pincode.");
        setLoadingc(true);
        return;
      }

      try {
        setLoading(true);
        const response = await axios.get(
          `https://api.postalpincode.in/pincode/${enteredPincode}`,
        );

        if (
          response.data &&
          response.data.length > 0 &&
          response.data[0].Status === "Success"
        ) {
          const postOffice = response.data[0].PostOffice[0];
          setNewodtItem((prevState) => ({
            ...prevState,
            city: postOffice.Block,
            dist: postOffice.District,
            state: postOffice.State,
            country: postOffice.Country,
          }));
          setLoadingc(false);
        } else {
          setNewodtItem((prevState) => ({
            ...prevState,
            city: "",
            dist: "",
            state: "",
          }));
          setPincodeError("Pincode not found.");
          setLoadingc(true);
        }
      } catch (error) {
        setPincodeError(
          "Error fetching pincode details. Please try again later.",
        );
      } finally {
        setLoading(false);
      }
    }
  };
  const handleEditContact = (doc) => {
    setNewodtItem({ ...doc });
  };

  const handleContactDelete = (index) => {
    confirmDelete(index).then((result) => {
      if (result.isConfirmed) {
        const newContacts = empcontact.filter((_, i) => i !== index);
        setEmpcontact(newContacts);
        showSuccessAlert();
      }
    });
  };

  const getCtypeLabel = (ctypeValue) => {
    const option = ctypeOptions.find((opt) => opt.value === ctypeValue);
    return option ? option.label : ctypeValue;
  };

  const fullName = `${newItem.name || ""} ${newItem.lastname || ""}`.trim();
  const initials =
    (
      (newItem.name || "").charAt(0) + (newItem.lastname || "").charAt(0)
    ).toUpperCase() || "U";
  const departmentLabel = (
    divisionData.find((o) => o.value === newItem.department) || {}
  ).label;
  const headerContact =
    empcontact && empcontact.length > 0 ? empcontact[0] : null;
  const isActive =
    !!newUser.active &&
    String(newUser.active) !== "0" &&
    String(newUser.active).toUpperCase() !== "N";

  const renderContactPreview = (doc, index) => {
    const typeLabel = getCtypeLabel(doc.ctype);
    const isOffice = String(typeLabel || "")
      .toLowerCase()
      .includes("office");
    const addressLines = [
      doc.addressline1,
      doc.addressline2,
      [doc.city, doc.pincode].filter(Boolean).join(" - "),
      [doc.dist, doc.state, doc.country].filter(Boolean).join(", "),
    ].filter(Boolean);

    return (
      <div className="ep-card" key={index}>
        <div className="ep-card-head">
          <div className={`ep-card-ico ${isOffice ? "is-office" : ""}`}>
            {isOffice ? <FaBuilding size={18} /> : <FaHome size={18} />}
          </div>
          <div className="ep-card-title">
            <span>{typeLabel || `Contact ${index + 1}`}</span>
            {!doc.id && (
              <span className="ep-badge ep-badge-temp">Temporary</span>
            )}
          </div>
          <div className="ep-card-actions">
            {doc.id && (
              <button
                onClick={() => handleEditContact(doc)}
                disabled={!doc.id || loading}
                type="button"
                className="ep-icon-btn"
                title="Edit contact"
                aria-label="Edit contact"
              >
                <FaPen size={14} />
              </button>
            )}
            <button
              onClick={() => handleContactDelete(index)}
              disabled={loading}
              type="button"
              className="ep-icon-btn is-danger"
              title="Delete contact"
              aria-label="Delete contact"
            >
              <FaTrashAlt size={14} />
            </button>
          </div>
        </div>

        <div className="ep-card-row">
          <FaMapMarkerAlt size={14} />
          <div>
            {addressLines.map((line, i) => (
              <div key={i}>{line}</div>
            ))}
          </div>
        </div>
        {doc.primaryphone && (
          <div className="ep-card-row">
            <FaPhoneAlt size={13} />
            <span>
              +91 {doc.primaryphone}
              {doc.secondaryphone ? `, +91 ${doc.secondaryphone}` : ""}
            </span>
          </div>
        )}
        {doc.emailid && (
          <div className="ep-card-row">
            <FaEnvelope size={13} />
            <span>{doc.emailid}</span>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <style>{profileCss}</style>
      <SucessModal
        show={ShowSucessModal}
        onClose={handleCloseSucessModal}
        headerText={titile}
        message={SucessMessage}
      />
      <div className="ep-page">
        {/* ---------- Profile header ---------- */}
        <div className="ep-hero">
          <div className="ep-avatar" aria-hidden="true">
            {initials}
          </div>
          <div className="ep-hero-main">
            <div className="ep-hero-top">
              <h2 className="ep-hero-name">{fullName || "Employee Profile"}</h2>
              {isActive && (
                <span className="ep-badge ep-badge-active">Active</span>
              )}
            </div>
            <div className="ep-hero-meta">
              {newItem.empid && (
                <span className="ep-pill">
                  <FaUser size={11} /> {newItem.empid}
                </span>
              )}
              {departmentLabel && (
                <span className="ep-pill">
                  <FaBuilding size={11} /> {departmentLabel}
                </span>
              )}
              {newItem.designation && (
                <span className="ep-pill">
                  <FaBriefcase size={11} /> {newItem.designation}
                </span>
              )}
            </div>
          </div>
          {headerContact && (
            <div className="ep-hero-contact">
              {headerContact.emailid && (
                <span>
                  <i className="ep-chip-icon">
                    <FaEnvelope size={14} />
                  </i>
                  {headerContact.emailid}
                </span>
              )}
              {headerContact.primaryphone && (
                <span>
                  <i className="ep-chip-icon">
                    <FaPhoneAlt size={13} />
                  </i>
                  +91 {headerContact.primaryphone}
                </span>
              )}
            </div>
          )}
        </div>

        {/* ---------- Tabs ---------- */}
        <div className="ep-tabs" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={tabValue === 0}
            className={`ep-tab ${tabValue === 0 ? "is-active" : ""}`}
            onClick={(e) => handleTabChange(e, 0)}
          >
            <FaUser size={15} /> Basic Details
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={tabValue === 1}
            className={`ep-tab ${tabValue === 1 ? "is-active" : ""}`}
            onClick={(e) => handleTabChange(e, 1)}
          >
            <FaMapMarkerAlt size={15} /> Contact Details
          </button>
        </div>

        <div className="ep-panel">
          {tabValue === 0 && (
            <div className="ep-section">
              <div className="ep-section-head">
                <div className="ep-section-title">
                  <i className="ep-chip-icon">
                    <FaUser size={15} />
                  </i>
                  <div>
                    <h3>Basic Details</h3>
                    <p>Manage your personal and employment information</p>
                  </div>
                </div>
              </div>

              <div className="ep-section-body">
                <div className="ep-grid">
                  <Field label="Employee ID / Login ID" error={errors.empid}>
                    <div className="ep-input-wrap">
                      <input
                        readOnly={true}
                        type="text"
                        className="ep-input has-ico-r"
                        placeholder="Enter Employee Id/Login Id"
                        value={newItem.empid}
                        onChange={(e) =>
                          setNewItem({ ...newItem, empid: e.target.value })
                        }
                      />
                      <span className="ep-ico-right">
                        <FaLock size={13} />
                      </span>
                    </div>
                  </Field>

                  <Field label="Password" error={errors.password}>
                    <div className="ep-input-wrap">
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter Password"
                        required
                        className="ep-input has-ico-r"
                        value={newUser.password}
                        onChange={(e) =>
                          setNewUser({ ...newUser, password: e.target.value })
                        }
                      />
                      <button
                        type="button"
                        className="ep-eye"
                        onClick={togglePasswordVisibility}
                        aria-label={
                          showPassword ? "Hide password" : "Show password"
                        }
                      >
                        {showPassword ? (
                          <FaEyeSlash size={17} />
                        ) : (
                          <FaEye size={17} />
                        )}
                      </button>
                    </div>
                  </Field>

                  <Field label="First Name" required error={errors.name}>
                    <input
                      type="text"
                      className="ep-input"
                      placeholder="Enter Name"
                      value={newItem.name}
                      onChange={(e) =>
                        setNewItem({ ...newItem, name: e.target.value })
                      }
                    />
                  </Field>

                  <Field label="Last Name">
                    <input
                      type="text"
                      className="ep-input"
                      placeholder="Enter Last Name"
                      value={newItem.lastname}
                      onChange={(e) =>
                        setNewItem({ ...newItem, lastname: e.target.value })
                      }
                    />
                  </Field>

                  <Field label="Gender" required error={errors.gender}>
                    <Select
                      isClearable
                      name="type"
                      options={genderOptions}
                      placeholder="Select Gender"
                      value={
                        genderOptions.find(
                          (option) => option.value === newItem.gender,
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        setNewItem({
                          ...newItem,
                          gender: selectedOption ? selectedOption.value : "",
                        })
                      }
                      styles={selectStyles}
                      classNamePrefix="select"
                    />
                  </Field>

                  <Field label="Department" required error={errors.department}>
                    <Select
                      isClearable
                      name="department"
                      options={divisionData}
                      placeholder="Select Department"
                      value={
                        divisionData.find(
                          (option) => option.value === newItem.department,
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        setNewItem({
                          ...newItem,
                          department: selectedOption
                            ? selectedOption.value
                            : "",
                        })
                      }
                      styles={selectStyles}
                      classNamePrefix="select"
                    />
                  </Field>

                  <Field
                    label="Designation"
                    required
                    error={errors.designation}
                  >
                    <div className="ep-input-wrap">
                      <span className="ep-ico-left">
                        <FaBriefcase size={14} />
                      </span>
                      <input
                        type="text"
                        className="ep-input has-ico"
                        placeholder="Enter Designation"
                        value={newItem.designation}
                        onChange={(e) =>
                          setNewItem({
                            ...newItem,
                            designation: e.target.value,
                          })
                        }
                      />
                    </div>
                  </Field>

                  <Field label="Supervisor">
                    <Select
                      isClearable
                      name="supervisor"
                      options={supervisorOptions}
                      placeholder="Select Supervisor"
                      value={
                        supervisorOptions.find(
                          (option) => option.value === newItem.supervisor,
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        setNewItem({
                          ...newItem,
                          supervisor: selectedOption
                            ? selectedOption.value
                            : "",
                        })
                      }
                      styles={selectStyles}
                      classNamePrefix="select"
                    />
                  </Field>
                </div>
              </div>

              <div className="ep-section-foot">
                <button
                  className="ep-btn ep-btn-primary"
                  onClick={handleUpdateEmployee}
                  disabled={loading}
                >
                  <FaSave size={14} /> Save Basic Details
                </button>
              </div>
            </div>
          )}

          {tabValue === 1 && (
            <>
              <div className="ep-section">
                <div className="ep-section-head">
                  <div className="ep-section-title">
                    <i className="ep-chip-icon">
                      <FaMapMarkerAlt size={15} />
                    </i>
                    <div>
                      <h3>Contact Details</h3>
                      <p>Manage your address and contact information</p>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="ep-btn ep-btn-outline"
                    onClick={clearFieldContact}
                    disabled={loading}
                  >
                    <FaPlus size={12} /> Add New Contact
                  </button>
                </div>

                {empcontact.length > 0 ? (
                  <div className="ep-contact-list">
                    {empcontact.map((doc, index) =>
                      renderContactPreview(doc, index),
                    )}
                  </div>
                ) : (
                  <div className="ep-empty">
                    No contact added yet. Fill the form below and choose Add to
                    List.
                  </div>
                )}

                <div className="ep-gap" />

                <div className="ep-sub-head">Add / Edit Contact</div>
                <div className="ep-section-body">
                  <div className="ep-grid">
                    <Field label="Address Type" required error={errors.ctype}>
                      <Select
                        isClearable
                        name="type"
                        options={ctypeOptions}
                        placeholder="Select Address Type"
                        value={
                          newodtItem.ctype
                            ? ctypeOptions.find(
                                (option) => option.value === newodtItem.ctype,
                              )
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleContactChange(
                            "ctype",
                            selectedOption ? selectedOption.value : "",
                          )
                        }
                        styles={selectStyles}
                        classNamePrefix="select"
                      />
                    </Field>

                    <Field
                      label="Pincode"
                      required
                      error={errors.pincode || pincodeError}
                    >
                      <div className="ep-pin-row">
                        <div className="ep-input-wrap">
                          <input
                            type="number"
                            min="0"
                            className="ep-input"
                            placeholder="Enter Pincode"
                            value={newodtItem.pincode}
                            onChange={(e) =>
                              handleContactChange("pincode", e.target.value)
                            }
                          />
                        </div>
                        <button
                          type="button"
                          className="ep-btn ep-btn-primary"
                          style={{ padding: "0 14px" }}
                          title="Look up pincode"
                          aria-label="Look up pincode"
                          onClick={() =>
                            handleContactChange(
                              "pincode",
                              String(newodtItem.pincode || ""),
                            )
                          }
                          disabled={loading}
                        >
                          <FaSearch size={14} />
                        </button>
                      </div>
                    </Field>

                    <Field
                      label="Address Line 1"
                      required
                      error={errors.addressline1}
                    >
                      <input
                        type="text"
                        className="ep-input"
                        placeholder="Enter Addressline1"
                        value={newodtItem.addressline1}
                        onChange={(e) =>
                          handleContactChange("addressline1", e.target.value)
                        }
                      />
                    </Field>

                    <Field label="Address Line 2">
                      <input
                        type="text"
                        placeholder="Enter Addressline2"
                        className="ep-input"
                        value={newodtItem.addressline2}
                        onChange={(e) =>
                          handleContactChange("addressline2", e.target.value)
                        }
                      />
                    </Field>

                    <Field label="City" span="ep-c3">
                      <input
                        disabled="disabled"
                        type="text"
                        className="ep-input"
                        placeholder="City"
                        value={newodtItem.city}
                        onChange={(e) =>
                          handleContactChange("city", e.target.value)
                        }
                      />
                    </Field>

                    <Field label="District" span="ep-c3" error={errors.dist}>
                      <input
                        disabled="disabled"
                        type="text"
                        className="ep-input"
                        placeholder="District"
                        value={newodtItem.dist}
                        onChange={(e) =>
                          handleContactChange("dist", e.target.value)
                        }
                      />
                    </Field>

                    <Field label="State" span="ep-c3">
                      <input
                        disabled="disabled"
                        type="text"
                        className="ep-input"
                        placeholder="State"
                        value={newodtItem.state}
                        onChange={(e) =>
                          handleContactChange("state", e.target.value)
                        }
                      />
                    </Field>

                    <Field label="Country" span="ep-c3">
                      <input
                        disabled="disabled"
                        type="text"
                        className="ep-input"
                        placeholder="Country"
                        value={newodtItem.country}
                        onChange={(e) =>
                          handleContactChange("country", e.target.value)
                        }
                      />
                    </Field>

                    <Field
                      label="Primary Phone"
                      required
                      span="ep-c4"
                      error={errors.primaryphone}
                    >
                      <div className="ep-input-wrap">
                        <span className="ep-ico-left">
                          <FaPhoneAlt size={13} />
                        </span>
                        <input
                          type="number"
                          min="0"
                          className="ep-input has-ico"
                          placeholder="Enter Phone Number"
                          value={newodtItem.primaryphone}
                          onChange={(e) =>
                            handleContactChange("primaryphone", e.target.value)
                          }
                        />
                      </div>
                    </Field>

                    <Field
                      label="Secondary Phone"
                      span="ep-c4"
                      error={errors.secondaryphone}
                    >
                      <div className="ep-input-wrap">
                        <span className="ep-ico-left">
                          <FaPhoneAlt size={13} />
                        </span>
                        <input
                          type="number"
                          min="0"
                          className="ep-input has-ico"
                          placeholder="Enter Phone Number"
                          value={newodtItem.secondaryphone}
                          onChange={(e) =>
                            handleContactChange(
                              "secondaryphone",
                              e.target.value,
                            )
                          }
                        />
                      </div>
                    </Field>

                    <Field label="Email ID" span="ep-c4" error={errors.emailid}>
                      <div className="ep-input-wrap">
                        <span className="ep-ico-left">
                          <FaEnvelope size={13} />
                        </span>
                        <input
                          type="text"
                          placeholder="Enter Email Id"
                          className="ep-input has-ico"
                          value={newodtItem.emailid}
                          onChange={(e) =>
                            handleContactChange("emailid", e.target.value)
                          }
                        />
                      </div>
                    </Field>

                    <div className="ep-c12 ep-form-actions">
                      <button
                        type="button"
                        className="ep-btn ep-btn-ghost"
                        onClick={clearFieldContact}
                        disabled={loading}
                      >
                        <FaTimes size={13} /> Clear
                      </button>
                      <button
                        onClick={handleAddContact}
                        disabled={loading || loadingc}
                        type="submit"
                        className="ep-btn ep-btn-primary"
                      >
                        <FaPlus size={12} />{" "}
                        {newodtItem.empcode ? "Update" : "Add to List"}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="ep-footer-wide">
                  <button
                    className="ep-btn ep-btn-green"
                    onClick={handleUpdateContact}
                    disabled={loading}
                  >
                    <FaSave size={15} /> Update Contact Details
                  </button>
                </div>
              </div>
            </>
          )}

          {loading && <CustomLoader />}
        </div>
      </div>
    </>
  );
};
export default SampEmpProfile;
